import React, { useState, useEffect } from "react";
import { getData, getCompanyList } from "../../../../serverRequest";
import LoadingSpinner from "../../../../components/Loadder";
//import moment from 'moment';
import { Link } from "react-router-dom";
import Select from 'react-select';
// components
import TallyListTable from "../../../../components/Tables/TallyListTable";

export default function TallyList() {
  const [totalTallies, setTotalTallies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalEntities, setTotalEntities] = React.useState([]);
  const [companies, setCompanies] = useState([]);
  const [companyData, setCompanyData] = useState();
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(1);

  const handleChange = selectedOption => {
    console.log(selectedOption);

    setSelectedCompany(selectedOption.value);
    setCompanyData(selectedOption.value);
    setSelectedOption(selectedOption);
  };

  const filterEntityData = (entities_data) => {
    //console.log(tickets_data);
    let totalEntity = [];
    if (entities_data) {
      for (let i = 0; i < entities_data.length; i++) {
        totalEntity.push(entities_data[i])
      }
    }


    setTotalEntities(totalEntity);
    return ({ "total": totalEntity })
  }


  React.useEffect(() => {
    async function fetchData() {
      let resData = await getData('/api/company?admin=1')
      let entities_data = resData['data']['entities']
      console.log(entities_data);
      let entitiesData = await filterEntityData(entities_data)

      setLoading(false);
    }
    fetchData();


  }, [])

  //const [open, setOpen] = React.useState(true);
  //const searchParams = new URLSearchParams(window.location.search);

  /* const ticketFilter = searchParams.get('filter');
    //console.log(ticketFilter);
    const toggleDrawer = () => {
      setOpen(!open);
    };
  
    const formatDate = (dateString) => {
      return moment(dateString).format('DD/MM/YYYY');
    }; */

  /* const filterTallyData = (tallies_data) => {
    //console.log(tickets_data);
    //let openTicket = [];
    //let closeTicket = [];
    let totaltally = [];
    if (tallies_data) {
      for (let i = 0; i < tallies_data.length; i++) {
        totaltally.push(tallies_data[i]);
      }
    }

    setTotalTallies(totaltally);
    return { total: totalTallies };
  };
 */

  const fetchCompanyData = async () => {
    let companyList = await getCompanyList();
    if (companyList && companyList['data']) {
      companyList = companyList['data']
      setCompanies(companyList);
      setSelectedOption(companyList[0]);
    }
  }

  useEffect(() => {
    async function fetchData() {
      try {
        let resData = await getData(
          '/api/employee/tally_backup/?employee_id=' +
          localStorage.getItem('employeeId')
        );
        let tallies_data = resData["data"]["backup_data"];
        console.log(tallies_data);

        // Update the state with fetched data
        setTotalTallies(tallies_data ? tallies_data : []);
      } catch (error) {
        console.error("Error fetching tally data:", error);
      } finally {
        // Ensure loading is set to false
        setLoading(false);
      }
    }
    fetchCompanyData()
    fetchData();
  }, []);

  return (
    <>
      <main>
        <div className="relative block py-24 lg:pt-0 px-4">
          <div className="rounded-t bg-white mb-0 px-6 py-6">
            <div className="text-center flex justify-between">
              <h6 className="text-blueGray-700 text-xl font-bold">
                Tally Data
              </h6>
              {/* <div className="w-full lg:w-4/12 px-4">
                <div className="relative w-full">
                  <Select
                    name="clist"
                    options={companies}
                    value={selectedOption}
                    onChange={(selectedOption) => {
                      handleChange(selectedOption);
                      setSelectedCompany(selectedOption.value);
                    }}
                    placeholder="Select Entity"
                  />
                </div>
              </div> */}
              <Link to="/admin/company/tallyForm">
                <button
                  className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                  type="button"
                >
                  Add
                </button>
              </Link>
            </div>
          </div>
          {loading ? (
            <LoadingSpinner></LoadingSpinner>
          ) : (
            <>
              <div
                className={
                  "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
                  ("light" === "light"
                    ? "bg-white"
                    : "bg-lightBlue-900 text-white")
                }
              >
                <div className="block w-full overflow-x-auto py-24 lg:pt-0 px-4">
                  {/* Projects table */}
                  {!loading && totalTallies.length > 0 ? (
                    <TallyListTable
                      totalTallies={totalTallies}
                    ></TallyListTable>
                  ) : (
                    <div className="text-center py-4">No data available</div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </main>
    </>
  );
}
